/**
 * The possible article types.
 */
export enum ArticleType {
  ClinicArticle = 'ClinicArticle',
  IndustryArticle = 'IndustryArticle',
}
